import { useQuery } from '@tanstack/react-query'
import { getCharterPromotionAvailableSeats } from 'api/flights'
import { CHARTER_PROMOTION_TYPES, type CharterPromotionType } from 'constants/charterFlight'

const CHARTER_PROMOTION_AVAILABLE_SEATS_STALE_TIME_MS = 60 * 1000

interface UseCharterFlightPromotionAvailableSeatsParams {
  enabled?: boolean
  /**
   * Each charter promotion tracks its own seat inventory, so the seat count is only
   * meaningful for the campaign being displayed.
   */
  promotionType?: CharterPromotionType
}

interface UseCharterFlightPromotionAvailableSeatsResult {
  availableSeats: number
  isLoading: boolean
  error: unknown
}

export default function useCharterFlightPromotionAvailableSeats(params: UseCharterFlightPromotionAvailableSeatsParams = {}): UseCharterFlightPromotionAvailableSeatsResult {
  const {
    enabled = true,
    promotionType = CHARTER_PROMOTION_TYPES.hundredDollar,
  } = params

  const { data, isLoading, isFetching, error } = useQuery({
    queryKey: ['charterFlightPromotionAvailableSeats', promotionType],
    queryFn: () => getCharterPromotionAvailableSeats(promotionType),
    enabled,
    staleTime: CHARTER_PROMOTION_AVAILABLE_SEATS_STALE_TIME_MS,
  })

  return {
    availableSeats: data?.seatsLeft ?? 0,
    isLoading: isLoading || isFetching,
    error,
  }
}
